export class SlideOutPanelController {
    public isOpen: boolean = false;
    public title: string = '';
    public errorMessage: string = '';
    public showSaveButton: boolean = true;
    public isLoading: boolean = false;
    public saveDisabled: boolean = false;
    public saveButtonText: string = 'Save';
    public cancelButtonText: string = 'Cancel';
    public deleteButtonText: string = 'Delete';
    public onSave: () => void;
    public onClose: () => void;
    public onDelete: () => void;

    /** @ngInject */
    constructor() {}

    public $onInit(): void {
        // Initialize component
    }

    public open(title: string, showSaveButton: boolean = true): void {
        this.isOpen = true;
        this.title = title;
        this.showSaveButton = showSaveButton;
        this.errorMessage = ''; // Clear any previous errors
        
        // Prevent body scroll
        document.body.classList.add('slide-out-panel-open');
    }

    public close(): void {
        this.isOpen = false;
        this.errorMessage = ''; // Clear errors when closing
        
        // Restore body scroll
        document.body.classList.remove('slide-out-panel-open');
        
        if (this.onClose) {
            this.onClose();
        }
    }

    public setError(message: string): void {
        this.errorMessage = message;
    }

    public clearError(): void {
        this.errorMessage = '';
    }
}

export const SlideOutPanelComponent: angular.IComponentOptions = {
    template: require('./slide-out-panel.component.html'),
    controller: SlideOutPanelController,
    controllerAs: '$ctrl',
    transclude: true,
    bindings: {
        isOpen: '<',
        title: '@',
        errorMessage: '<',
        showSaveButton: '<',
        isLoading: '<',
        saveDisabled: '<',
        saveButtonText: '@',
        cancelButtonText: '@',
        deleteButtonText: '@',
        onSave: '&',
        onClose: '&',
        onDelete: '&'
    }
};



// WEBPACK FOOTER //
// ./src/components/slide-out-panel/slide-out-panel.component.ts